import { Box, Icon, Text, Flex } from '@chakra-ui/react';

import Heading from './Heading';
import {AiOutlineHtml5,AiFillGithub} from "react-icons/ai"
import {TbBrandCss3} from "react-icons/tb"
import {TbBrandJavascript} from "react-icons/tb"
import {FaReact} from "react-icons/fa"
import {SiChakraui,SiExpress,SiChartdotjs} from "react-icons/si"
import {PiTreeStructureLight} from "react-icons/pi"
import {SiRedux} from "react-icons/si"
import {SiMongodb,SiNodedotjs,SiTailwindcss,SiPostman} from "react-icons/si" 
import "./Stack.css"
import SoftSkills from './Skills';

export default function TechStack({id}){

  const arr =[
    {image:AiOutlineHtml5,text:"HTML"},
    {image:TbBrandCss3, text:"CSS"},
    {image:TbBrandJavascript, text:"JavaScript"},
    {image:FaReact, text:"React"},
    {image:SiChakraui, text:"ChakraUI"},
    {image:SiRedux, text:"Redux"},
    {image:SiMongodb, text:"MongoDB"},
    {image:SiExpress,text:"Express"},
    {image:SiNodedotjs,text:"Node JS"},
    {image:SiTailwindcss,text:"TailWind"},
    {image:SiChartdotjs,text:"Chart JS"},
    {image:AiFillGithub,text:"Git"},
    {image:SiPostman,text:"Postman"},
    {image:PiTreeStructureLight, text:"DSA"},
  ]

  //express,node,tailwind,chart js
  return (
    <>
    <Box p={4} id={id}>
       <Heading
        text={`TechStack`}
        style={{ marginTop: '64px', marginBottom:'50px' }}
        size="lg"
        />
        <div className='wrapper'>
 
       {/* should id be at this flex instead */}
  <Flex className='stack' width={"90%"} justifyContent={"space-evenly"} margin={"auto"} gap={5}  flexWrap="wrap">
    {arr.map((ele) => (
      <Flex className='skills-card' direction="column" align="center" justify="center">
        <Icon className='skills-card-img' as={ele.image} w={100} h={100} />
        <Text className='skills-card-name' fontWeight={600} mt={2}>
          {ele.text}
        </Text>
      </Flex>
    ))}
  </Flex>
  </div>
 
</Box>
<SoftSkills/>
</>
  )
}